import { useParams } from "react-router-dom";

import { Box, Divider, useColorScheme } from "@mui/joy";

import { IProjectList } from "../../../../../../interfaces";
import { useProject } from "../../../../../../hooks/query";

import { Navigation } from "./Navigation";
import { Basic } from "./Basic";
import { Customer } from "./Customer";
import { Insurance } from "./Insurance";
import { ProjectTimeline } from "./ProjectTimeline";

import "./index.scss";
import { Shield, SquareLibrary, User, History } from "lucide-react";

export default function Overview() {
    const params = useParams();
    const id = params.id as string;

    const { useGetProjectById } = useProject();
    const { data: projectDetails } = useGetProjectById(id);

    return (
        <Box mt={0.5}>
            <Map details={projectDetails} />
            <Divider sx={{ mt: 2 }} />
            <Box display={"flex"} gap={2} mt={2}>
                <Navigation
                    tabList={[
                        {
                            name: "Basic",
                            icon: <SquareLibrary size={18} />,
                            component: <Basic details={projectDetails} />,
                        },
                        {
                            name: "Timeline",
                            icon: <History size={18} />,
                            component: <ProjectTimeline details={projectDetails} />,
                        },
                        {
                            name: "Customer",
                            icon: <User size={18} />,
                            component: <Customer details={projectDetails} />,
                        },
                        {
                            name: "Insurance",
                            icon: <Shield size={18} />,
                            component: <Insurance details={projectDetails} />,
                        },
                    ]}
                />
            </Box>
        </Box>
    );
}

function Map({ details }: { details: IProjectList | null }) {
    const { mode } = useColorScheme();
    const isDark = mode === "dark";

    const address = details ? `${details.CustomerStreet}, ${details.CustomerCity}, ${details.CustomerZipCode}` : "";

    const encodedAddress = encodeURIComponent(address);
    const mapUrl = address
        ? `https://maps.google.com/maps?q=${encodedAddress}&t=&z=13&ie=UTF8&iwloc=&output=embed`
        : "https://maps.google.com/maps?q=Colorado&t=&z=13&ie=UTF8&iwloc=&output=embed";

    const mapFilter = isDark
        ? "invert(1) hue-rotate(180deg) grayscale(0.7) contrast(0.95)"
        : "grayscale(0.7) contrast(1.1)";

    return (
        <iframe
            width="100%"
            height="180"
            src={mapUrl}
            style={{
                borderRadius: "12px",
                filter: mapFilter,
                border: isDark ? "1px solid rgba(255,255,255,0.1)" : "1px solid var(--standard-palette-divider)",
            }}
            title="Project Location Map"
        ></iframe>
    );
}
